import React from 'react'

import Script from 'dangerous-html/react'

import './contact-form7.css'

const ContactForm7 = (props) => {
  return (
    <div className="contact-form7-thq-contact1-elm thq-section-padding">
      <div className="contact-form7-container1">
        <div className="contact-form7-container2">
          <Script
            html={`<script type="text/javascript" src="https://form.jotform.com/jsform/260464460700046"></script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default ContactForm7
